import { createApp } from './create-app'
import { createVuetify } from './create-vuetify'

export function createVuetifyApp(App: Vue.Component, options: any = {}) {
  const vuetify = createVuetify()
  return createApp(App, Object.assign(options, { vuetify }))
}
